module.exports = __webpack_public_path__ + "static/assets/7569623cd83d4ceab6b37c1541d656af.svg";